import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

export const createAccount = (email, password) => {
  const auth = getAuth();
  return createUserWithEmailAndPassword(auth, email, password);
}

export const signIn = (email, password) => {
  const auth = getAuth();
  return signInWithEmailAndPassword(auth, email, password);
}

export const getCurrentUser = (callback = () => { }) => {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      callback(user);
    } else {
      callback(null);
    }
  });
};

export const logout = () => {
  const auth = getAuth();
  return signOut(auth);
}

export const create2Account = (auth, email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
}
